import { Connection } from "@solana/web3.js";

export const SOLANA_RPC_URL =
  "https://api.devnet.solana.com";

export const connection = new Connection(
  SOLANA_RPC_URL,
  "confirmed"
);

export const getPhantomProvider = () => {
  if (typeof window === "undefined") {
    return null;
  }

  const provider =
    window?.phantom?.solana ||
    (window?.solana?.isPhantom
      ? window.solana
      : null);

  if (!provider?.isPhantom) {
    return null;
  }

  return provider;
};

export const connectPhantom = async () => {
  const provider = getPhantomProvider();

  if (!provider) {
    throw new Error(
      "Phantom Wallet is not installed. Please install the Phantom browser extension."
    );
  }

  const response = await provider.connect();

  const publicKey =
    response?.publicKey ||
    provider.publicKey;

  if (!publicKey) {
    throw new Error(
      "Phantom connected, but no Solana public key was returned."
    );
  }

  return publicKey.toString();
};

export const disconnectPhantom = async () => {
  const provider = getPhantomProvider();

  if (provider) {
    await provider.disconnect();
  }
};
